import type { FaireProductEntity } from "../../entity_types/product";

export const p_b5fs9zu4jv: FaireProductEntity = {
  token: "p_b5fs9zu4jv",
  type: "product",
  name: "Mineral Magic Bundle - 87-Piece Organic Makeup + FREE Bags",
  brandToken: "b_f2ec5373",
  brandName: "BEE-OCH Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/d88e3ae7525f78990285402f7b6a99403e4529f3bb11eeddec6481a861686529.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0b71922241aa65f7dbbe7fc323766efdb855075dd5bcc9327dec843fc068269.png",
    "https://cdn.faire.com/fastly/bf66f3b93b2c0907cbd981a549f553944b2001485cad570cdb99efb301cb5c8d.jpeg",
    "https://cdn.faire.com/fastly/ef3ecdfefc0328b6b1f1aa93d1c0ae30db737553dccd58ad430155fe58a4ca69.webp",
    "https://cdn.faire.com/fastly/90e2e451164594242e774a28513ba933074671689fe71c9c13c548bb6bd5934b.jpeg",
    "https://cdn.faire.com/fastly/e6edb2f1ea0f0dca84c1158697dff8fc3033bdbeddad4d9a459d7be0499c2c68.jpeg",
    "https://cdn.faire.com/fastly/81c0d6ff923fb0b8df9a1333b4e6d790596c5d2b349110adee83d13188e15a7e.jpeg",
    "https://cdn.faire.com/fastly/429bf4dba11ee5164e6c0e2e81269e96529b678495d2134529ed286107d9d894.png",
    "https://cdn.faire.com/fastly/b93d9ca5f5bbb6b1ad64de9e17d882a4a01302084f208ef749265c2a8aab8e3e.png",
    "https://cdn.faire.com/fastly/612c9dc8cfd38e8639874029254170147e1165cf5a9927ad535e47d183d1484f.png",
    "https://cdn.faire.com/fastly/105a5fff073fdc7f6c5fa2826c69d918c9b7f2e207f5690f3bd0e26a7d12bbc0.png",
    "https://cdn.faire.com/fastly/e56a0ab802364997505ea4e05749d843ebd98ebbbca767771fcb053f42486f12.jpeg",
    "https://cdn.faire.com/fastly/ca3070e54b8dd1951d1c5e9c37f71803361e21f649e0150729bd6fad09d0a613.jpeg",
    "https://cdn.faire.com/fastly/ead5b05e961b004fc50ee294d330ad9a42b945750cc84e1ae9cd620c768cb9c6.jpeg",
    "https://cdn.faire.com/fastly/c3c91294e29cf360dc4707e809f6393700262ff7ccbc61d40e4a792fcb88b085.jpeg",
  ],
  priceDollars: 887,
  description:
    "Introducing our Mineral Magic Bundle! Discover the Clean Beauty Difference! This bundle offers the full line of our ultra- clean mineral-based makeup products with minimal ingredients + natural sun protection! Over $1300 Retail Value + FREE Cosmetic Bags!\n\nNEW! Tinted Moisturizer - 24% Natural Sunscreen Minerals (30mL)\n3 x - Valerie\n3 x - Tiffany\n3 x - Katie\n3 x - Vivian\n\nTinted Mineral Sunscreen Foundation - 31% Natural Sunscreen Minerals (1/2 oz Twist Up Tube\n3 x - Valerie\n3 x - Tiffany\n3 x - Katie\n3 x - Vivian\n\nTinted Mineral Powder - 80% Natural Sunscreen Minerals:\n3 x - Valerie\n3 x - Tiffany\n3 x - Katie\n3 x - Vivian\n\nTinted Lip Balm Display Boxes - 10% Natural Sunscreen Minerals\n12 x - Brick Rose with Display Box\n12 x - Royal Blush with Display Box\n12 x - Peachy Dream with Display Box\n\n5 x Bamboo Kabuki Brush\n\n5 x Foundation Brush\n\n5 x Oil Cleanser 1oz\n\nFREE 4 x Cosmetic Bags\n\n**Adding Testers Includes 1 of every shade of every product! (15 pieces) at 50% off Wholesale Pricing!**",
  tags: [],
  msrpDollars: 1774,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:27.747Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
